// JWT payload는 base64url(`-`/`_`, 패딩 없음)로 인코딩되어 있어
// naive atob는 throw한다. 표준 base64로 치환하고 패딩을 보정한다.
function decodeBase64Url(segment) {
    const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return atob(padded);
}

// JWT의 exp(초 단위 epoch)를 반환. 파싱 불가/exp 부재 시 null.
export function getTokenExpiry(token) {
    if (!token || typeof token !== "string") return null;
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    try {
        const payload = JSON.parse(decodeBase64Url(parts[1]));
        return typeof payload.exp === "number" ? payload.exp : null;
    } catch {
        return null;
    }
}
